require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-crime-prevention.json") })
        }
      }, "path---tags-crime-prevention");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-crime-prevention!./.cache/json/tags-crime-prevention.json
// module id = 1000
// module chunks = 231608221292675